<template>
	<div style="width:90%">
		<el-button type="primary" size="small" style="margin:1%" round @click="editialogVisible()">新增账号</el-button>
		<el-table :data="roleData.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="id" label="序号" sortable align="center">
			</el-table-column>
			<!-- <el-table-column prop="logo" label="头像" align="center">
				<template slot-scope="scope">
					<img :src="scope.row.logo" alt="" style="width: 50px;height: 50px;border-radius: 50px;">
				</template>
			</el-table-column> -->
			<el-table-column prop="username" label="登录名" align="center">
			</el-table-column>
			<el-table-column prop="name" label="姓名" align="center">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center">
			</el-table-column>
			<el-table-column prop="email" label="邮箱" align="center">
			</el-table-column>
			<el-table-column prop="isEnable" label="状态" align="center">
				<template slot-scope="scope">
					<span v-if="scope.row.isEnable" style="color: green;">启用</span>
					<span v-else style="color: red;">禁用</span>
				</template>
			</el-table-column>

			<el-table-column prop="createDate" label="创建时间" :formatter="formartDate" align="center">
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center" width="250px">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click.native="bianji(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click.native="dialogVisibleFun(scope.row.id)">角色授权</el-button>
					<el-button size="small" type="text" @click.native="warehouseDialog(scope.row)">仓库授权</el-button>
					<el-dropdown trigger="click">
						
						<el-button style="  font-size: 10px;color: black;" type="text" size="small">
						<span style="padding-left: 10px;">更多</span>	
							<el-icon class="el-icon-caret-bottom"></el-icon>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							
							<el-dropdown-item @click.native="editialogVisible(scope.row.id)">重置登录密码</el-dropdown-item>

						
							<el-dropdown-item @click.native="toDeleteRole(scope.row.id)">删除</el-dropdown-item>
						
							<el-dropdown-item v-if="scope.row.isEnable" @click.native="enable(scope.row.id,scope.row.isEnable)">禁用</el-dropdown-item>
							<el-dropdown-item v-else @click.native="enable(scope.row.id,scope.row.isEnable)">启用</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					　　　　　
					　　　　
				</template>
				　　</el-table-column>
		</el-table>

		<el-pagination style="margin: 20px;" background :current-page="roleData.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="roleData.total" @size-change="handleSizeChange">
		</el-pagination>


		<!-- 编辑 -->
		<el-dialog style="float:rigin" title="编辑" :visible.sync="editDialogVisible2" width="35%"
		:close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
					<el-form-item :label-width="formLabelWidth" label="头像:">
						<el-col :span="7">
							<el-upload
							  class="avatar-uploader"
							  :action="httpurl"
							  :show-file-list="false"
							  :on-success="handleAvatarSuccess"
							  :before-upload="beforeAvatarUpload">
							  <img v-if="imageUrl" :src="imageUrl" class="avatar" style="width: 100%;height: 100%;border-radius: 50px;">
							  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-col>
					</el-form-item>
					<el-form-item  :label-width="formLabelWidth" label="登录名:">
						<el-col :span="13">
							<el-input v-model="form.username" placeholder="请修改登录名" />
						</el-col>
					</el-form-item>
					<el-form-item  :label-width="formLabelWidth" label="姓名:">
						<el-col :span="13">
							<el-input v-model="form.name" placeholder="请修改姓名" />
						</el-col>
					</el-form-item>
					
					<el-form-item  :label-width="formLabelWidth" label="手机号:">
						<el-col :span="13">
							<el-input v-model="form.phone" placeholder="请输入手机号" />
						</el-col>
					</el-form-item>
					
					<el-form-item :label-width="formLabelWidth" label="邮箱:">
						<el-col :span="13">
							<el-input v-model="form.email" placeholder="请输入邮箱" />
						</el-col>
					</el-form-item>
					<el-form-item style="display: flex;justify-content: space-between;width: 100%;">
						<el-button :loading="loading" type="primary" @click="toEdit2()">提交</el-button>
						<el-button @click="editDialogVisible2 = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		
		
		<!-- <el-dialog style="float:rigin" title="修改安全密码" :visible.sync="editDialogVisible1" width="35%"
		:close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">

					<el-form-item :label-width="formLabelWidth" label="新密码:">
						<el-col :span="10">
							<el-input type="password" v-model="form.walletPassword" placeholder="请输入新安全密码" />
						</el-col>
					</el-form-item>
					<el-form-item :label-width="formLabelWidth" label="确认新密码:">
						<el-col :span="10">
							<el-input type="password" v-model="form.surewalletPassword" placeholder="请输入新安全密码" />
						</el-col>
					</el-form-item>


					<el-form-item>
		 			<el-button :loading="loading" type="primary" @click="toEdit1()">提交</el-button>
						<el-button @click="editDialogVisible1 = false">取 消</el-button>
				
					</el-form-item>
				</el-form>
			</div>
		</el-dialog> -->
		<el-dialog style="float:rigin" :title="titleName+'2344'" :visible.sync="editDialogVisible" width="35%"
		:close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
					<el-form-item v-if="!ids" :label-width="formLabelWidth" label="登录名:">
						<el-col :span="13">
							<el-input v-model="form.username" placeholder="请输入登录名" />
						</el-col>
					</el-form-item>
					<el-form-item v-if="!ids" :label-width="formLabelWidth" label="姓名:">
						<el-col :span="13">
							<el-input v-model="form.name" placeholder="请输入姓名" />
						</el-col>
					</el-form-item>

					<el-form-item v-if="ids" :label-width="formLabelWidth" label="新密码:">
						<el-col :span="13">
							<el-input type="password" v-model="form.password" placeholder="请输入新密码" />
						</el-col>
					</el-form-item>

					<el-form-item v-if="ids" :label-width="formLabelWidth" label="确认新密码:">
						<el-col :span="13">
							<el-input type="password" v-model="form.surePass" placeholder="请输入新密码" />
						</el-col>
					</el-form-item>

					<el-form-item v-if="!ids" :label-width="formLabelWidth" label="登录密码:">
						<el-col :span="13">
							<el-input type="password" v-model="form.password" placeholder="请输入登录密码" />
						</el-col>
					</el-form-item>
					<el-form-item v-if="!ids" :label-width="formLabelWidth" label="手机号:">
						<el-col :span="13">
							<el-input v-model="form.phone" placeholder="请输入手机号" />
						</el-col>
					</el-form-item>

					<!-- <el-form-item v-if="!ids" :label-width="formLabelWidth" label="安全密码:">
						<el-col :span="13">
							<el-input type="password" v-model="form.walletPassword" placeholder="请输入安全密码" />
						</el-col>
					</el-form-item> -->
					<el-form-item style="display: flex;justify-content: space-between;">
						<el-button :loading="loading" type="primary" @click="toEdit()">提交</el-button>
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<!-- 角色授权 -->
		<el-dialog style="float:rigin" title="角色授权" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
			<el-checkbox-group v-model="userDataList" v-for="(item,index) in userData" :key="index">
				<el-checkbox :key="index-1" :label="item.roleId">{{item.roleName}}</el-checkbox>
			</el-checkbox-group>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="insertRoleFun">确 定</el-button>
			</span>
		</el-dialog>


		<!-- 仓库授权 -->
		<el-dialog style="float:rigin" title="仓库授权" :visible.sync="warehousedialogVisible" width="30%" :close-on-click-modal="false">
			<el-radio-group v-model="radioClick">
				<!-- @input="radioGroupChange" -->
				<el-radio :label="3" border>全部仓库</el-radio>
				<el-radio :label="6" border>指定仓库</el-radio>
			</el-radio-group>
			<div v-if="radioClick==6" style="padding-top:10px;">
				<el-checkbox-group v-model="warehouseDataList" v-for="(item,index) in warehouseData" :key="index">
					<el-checkbox :key="index-1" :label="item.id">{{item.warehouseName}}</el-checkbox>
				</el-checkbox-group>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="warehousedialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="warehouseRoleFun" :loading="loadingwarehouse">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	export default {
		data() {
			return {
				loading: false,
				roleData: [{}], //用户列表
				editDialogVisible: false,
				editDialogVisible1: false,
				dialogVisible: false,
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "200px",
				editDialogVisible2:false,
				imageUrl:'',
				httpurl:urls,
				page: {
					pageNum: 1,
					pageSize: 10
				},
				form: {
					username: "",
					password: "",
					surePass: "",
					email:"",
					surewalletPassword:"",
					phone:""
				},
				mainFormRules: {
					username: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
					password: {
						required: true,
						message: "请输入新密码",
						trigger: "blur"
					},
					surePass: {
						required: true,
						message: "请输入新密码",
						trigger: "blur"
					},
				},
				titleName: "",

				warehousedialogVisible: false,
				warehouseData: [],
				warehouseDataList: [], //仓库列表选中的
				radioClick: '',
				loadingwarehouse: false,
				manageIDL: '',
			};
		},

		methods: {
			enable(id,flag){
				// console.log(id,flag);
				
					this.$api.deactivateSysUser(id).then((res) => {
						if (res.state == 'success') {
							
						this.$message({
							message: res.message,
							type: 'success'
						});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
			
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = file.response.message
			},
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return  isLt2M;
			},
			//编辑弹框
			bianji(id){
				this.ids=id
				this.editDialogVisible2 = true;
				this.$api.findManageUserById(id).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('编辑查询--',res.data);
					if(res.state=='success'){
						this.imageUrl=res.data.logo
						this.form = res.data
						// this.form.username = res.data.username
						// this.form.name = res.data.name
						// this.form.phone = res.data.phone
						// this.form.email = res.data.email
					}
				})
			},
			editialogVisible(id) {
				this.form = {}
				if (id) {
					//编辑
					this.ids = id
					this.titleName = "重置密码"
					// this.findSysUserById(id);
				} else {
					this.ids = ""
					this.titleName = "添加"
				}
				this.editDialogVisible = true;
			},
			editialogVisible1(id) {
				this.editDialogVisible1 = true;
				this.ids = id
			},
			findSysUserById(id) {
				this.$api.findSysUserById(id).then((res) => {
					if (res.state == 'success') {
						this.form.username = res.data.username
					}
				})
			},
			toEdit2(){
				if (this.form.logo == '') {
					this.$message.error("请上传头像");
					return false;
				}
				if (this.form.username.length <= 2) {
					this.$message.error("用户名不能低于三位");
					return false;
				}
				if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.form.phone)) {
					this.$message.error("请输入正确手机号");
					return false;
				}
				// if (!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.form.email)) {
				// 	this.$message.error("请输入正确格式的邮箱");
				// 	return false;
				// }


				let data={
					id:this.ids,
					logo:this.imageUrl,
					username:this.form.username,
					name:this.form.name,
					phone:this.form.phone,
					email:this.form.email
				}
				
				this.$api.editSysUser(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible2 = false;
						this.getUserList();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			toEdit1() {
				if (this.form.surewalletPassword !== this.form.walletPassword) {
					this.$message.error("两次安全密码不一致");
					return false;
				}
				let data = {
					id: this.ids,
					walletPassword: this.form.walletPassword,
				}
				this.$api.retrievePassword(this.$encrypt(data)).then(res => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible1 = false;
						this.getUserList();
					} else {
					 this.$message.error(res.message);
					}
				})
			},
			toEdit() { //新增角色权限列表
				if (this.ids) {
					//重置密码
					if (this.form.password !== this.form.surePass) {
						this.$message.error("两次密码不一致");
						return false;
					}
					let data = {
						id: this.ids,
						username: this.form.username,
						password: this.form.password,

					}
					// console.log(data);
					this.$api.editSysUserPassword(this.$encrypt(data)).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
				} else {
					//添加
					this.loading = true
					let data = {
						username: this.form.username,
						name: this.form.name,
						password: this.form.password,
						walletPassword: this.form.walletPassword,
						phone: this.form.phone
					}

					this.$api.insertSysUser(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.loading = false
							this.editDialogVisible = false;
							this.getUserList();
						} else {
							this.loading = false
							this.$message.error(res.message);
						}
					})
				}
			},
			warehouseDialog(e){ // 打开仓库授权弹窗
				// console.log('123--', e)
				this.manageID = e.id;
				this.warehouseDataList = []
				this.warehousedialogVisible = true
				this.radioClick = e.warehouseIds ? 3 : 6;
				this.$api.findWarehouseByUserId(e.id).then((res) => {
					// res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						// console.log('345--',res);
						var newArr = [] //需要展示的数据
						res.data.forEach(item => {
							if(item.isManager){
								newArr.push(item.id)
							}
						});
						this.warehouseData = res.data 
						this.warehouseDataList = newArr //需要展示的数据
						// console.log('全部仓库---', this.warehouseData);
						// console.log('该用户拥有的仓库权限---', this.warehouseDataList);
					}
				})
			},
			radioGroupChange(e){ //单选组变化事件
				// if(e==6){
				// 	// WarehouseLis(){
				// 	this.$api.getWarehouseListNoParameter({
				// 		status: 1
				// 	}).then((res) => {
				// 		// console.log('2344--',res.data)
				// 		if (res.state == 'success') {
				// 			this.warehouseData = res.data
				// 		}
				// 	})
				// // },
				// }
			},
			warehouseRoleFun(){ //添加用户仓库权限
				this.loadingwarehouse = true;
				let warehouseIds = this.radioClick==3 ? true:false;
				let data = {
					warehouseIds: warehouseIds,
					manageId: this.manageID
				}
				if(!warehouseIds){
					data.ids = this.warehouseDataList.join(',')
				}
				// console.log('345--', data)
				this.$api.insertWarehouseFunction(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.warehousedialogVisible = false;
						this.getUserList();
					} else {
						this.$message.error(res.message);
					}
					
					this.loadingwarehouse = false
				})
				
			},
			// 打开角色授权弹窗
			dialogVisibleFun(id) {
				this.userDataList = []
				this.ids = id
				this.dialogVisible = true;
				this.$api.findRoleByUserId(id).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						// console.log(res);
						var newArr = [] //需要展示的数据
						// var item = ''
						res.data.forEach(item => {
							newArr.push(item.roleId)
						
						});
						this.userDataList = newArr //需要展示的数据
						// console.log('该用户拥有的角色权限---', this.userDataList);
					}
				})
				this.$api.queryManageRoleWhere().then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					this.userData = res.data
				})
			},
			//添加用户权限
			insertRoleFun() {
				let data = {
					userId: this.ids,
					roleIdArray: this.userDataList
				}
				this.$api.insertUserRole(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						this.$message.error(res.message);
					}
					this.dialogVisible = false;
				})
			},
			//删除角色
			toDeleteRole(id) {
				this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteSysUser(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserList()
			},
			formartDate(row, column) {
				var time = new Date(row.createDate);
				var ymdhis = "";
				ymdhis += time.getFullYear() + "-";
				ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
				ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
				ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
				ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
				ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
				return ymdhis;
			},
			getUserList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize
				}
				this.$api.queryManageUserWhere(this.$encrypt(data)).then((res) => { //角色管理列表
					// console.log('角色管理列表:', res);
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.roleData = res.data
						this.loading = false
					}
				})
			},
		},
		created() {
			this.getUserList();
		}
	};
</script>

<style scoped="lang">
	 .avatar-uploader,.el-upload {
	    /* border: 1px dashed #d9d9d9; */
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
		
	  }
	  .avatar-uploader,.el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 50px;
	    height: 50px;
	    /* line-height: 50px; */
	    text-align: center;
	  }
	  .avatar {
	    width: 50px;
	    height: 50px;
	    display: block;
	  }
</style>
